import { FC } from "react";
import { Grid } from "@mui/material";
import { InnerBox } from "@/components/elements/InnerBox";
import { ItemInfo } from "@/components/commons/ItemInfo";
import { CompanyFormTitle } from "@/features/company/components/company-info/CompanyFormTitle";
import { TGetCompanyDto } from "@/api/services/main/company/dtos/get-company.dto";
import { formatIdWithPrefix } from "@/utils/number";

type TCompanyUserOrgInfoProps = {
  companyData: TGetCompanyDto;
};

export const CompanyUserOrgInfo: FC<TCompanyUserOrgInfoProps> = ({ companyData }) => {
  return (
    <InnerBox title={<CompanyFormTitle text="所属機関情報" />} showDivider={false}>
      <Grid container spacing={3} sx={{ marginTop: "8px" }}>
        <Grid item xs={6}>
          <ItemInfo label="会社・法人名" value={companyData.companyName} isShowDivider={false} />
        </Grid>
        <Grid item xs={6}>
          <ItemInfo label="組織ID" value={formatIdWithPrefix(companyData.id, "S")} isShowDivider={false} />
        </Grid>
      </Grid>
    </InnerBox>
  );
};
